export default "__VITE_ASSET__DyAfKnzk__"